module.exports = __webpack_public_path__ + "media/bootstrap-icons/suit-heart-d27afb2f.svg";